module.exports = __webpack_public_path__ + "img/work-admin-panel.1a4dc8a5.png";